function ArtworkSection({ id, className = '', image, children }) {
    const classes = ['artwork', className].filter(Boolean).join(' ');

    return (
        <section id={id} className={classes}>
            <picture className="artwork-media">
                <img
                    className="artwork-background"
                    src={image.jpg}
                    srcSet={image.srcSet}
                    sizes={image.srcSet ? '100vw' : undefined}
                    alt=""
                    loading="eager"
                />
            </picture>
            {children}
        </section>
    );
}

export default ArtworkSection;
